import { render, staticRenderFns } from "./peosonInfo.vue?vue&type=template&id=7b9fa5ca&scoped=true"
import script from "./peosonInfo.vue?vue&type=script&lang=js"
export * from "./peosonInfo.vue?vue&type=script&lang=js"
import style0 from "./peosonInfo.vue?vue&type=style&index=0&id=7b9fa5ca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9fa5ca",
  null
  
)

export default component.exports